import type { Node as PMNode } from '@tiptap/pm/model';

export function findShortAnswerAnswerChild(doc: PMNode, shortAnswerOrQuestionPos: number): { pos: number; node: PMNode } | null {
    let $pos;
    try {
        $pos = doc.resolve(shortAnswerOrQuestionPos);
    } catch {
        return null;
    }

    let shortAnswerNode: PMNode | null = null;
    let shortAnswerStart: number | null = null;

    for (let d = $pos.depth; d > 0; d--) {
        const n = $pos.node(d);
        if (n.type.name === 'shortAnswer') {
            shortAnswerNode = n;
            shortAnswerStart = $pos.before(d);
            break;
        }
    }

    if (!shortAnswerNode || shortAnswerStart == null) {
        return null;
    }

    let cur = shortAnswerStart + 1;
    let found: { pos: number; node: PMNode } | null = null;
    shortAnswerNode.forEach(child => {
        if (child.type.name === 'shortAnswerAnswer') {
            found = { pos: cur, node: child };
        }
        cur += child.nodeSize;
    });

    return found;
}
